import Model, {
  attr,
  belongsTo,
  hasMany,
  type SyncHasMany,
} from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';
import type CompanyModel from './company';
import type UserModel from './user';
import type LocationItemModel from './location-item';

export default class LocationModel extends Model {
  declare [Type]: 'location';
  @attr()
  declare name: string;
  @attr()
  declare active: boolean;
  @belongsTo('company', { async: false, inverse: 'locations' })
  declare company: CompanyModel;
  @attr()
  declare created_at: string;
  @attr()
  declare updated_at: string;
  @belongsTo('user', { async: false, inverse: null })
  declare created_by: UserModel;
  @belongsTo('user', { async: false, inverse: null })
  declare updated_by: UserModel;

  @hasMany('location-item', { async: false, inverse: 'location' })
  declare locationItems: SyncHasMany<LocationItemModel>;
}
